import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';
import toast from 'react-hot-toast';

const initialState = {
  loading: false,
  vehicleTypesList: []
};
const vehicleTypesReducer = createSlice({
  name: 'vehicleTypes',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },
    getVehicleTypesList(state, action) {
      return {
        ...state,
        vehicleTypesList: action.payload?.data
      };
    },
    getVehicleTypeById(state, action) {
      return {
        ...state,
        vehicleTypeInfo: action.payload?.data
      };
    },
    getVehicleTypeLayouts(state, action) {
      return {
        ...state,
        vehicleTypeLayouts: action.payload?.data
      };
    }
  }
});

export default vehicleTypesReducer.reducer;

export const vehicleTypesActions = vehicleTypesReducer.actions;

export const createVehicleType = (role) => async () => {
  try {
    const res = await api.post(`api/VehicleType`, role);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const editVehicleType = (data, id) => async () => {
  try {
    const res = await api.put(`api/VehicleType/${id}`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const getVehicleTypesAction = (data) => async (dispatch) => {
  dispatch(vehicleTypesActions.setLoading(true));
  try {
    const res = await api.get(`api/VehicleType`, { params: data });
    if (res.status === 200 && res?.data) {
      dispatch(vehicleTypesActions.getVehicleTypesList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(vehicleTypesActions.setLoading(false));
  }
};
export const getVehicleTypeById = (id) => async (dispatch) => {
  dispatch(vehicleTypesActions.setLoading(true));
  try {
    const res = await api.get(`api/VehicleType/${id}`);
    if (res.status === 200 && res?.data) {
      dispatch(vehicleTypesActions.getVehicleTypeById(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(vehicleTypesActions.setLoading(false));
  }
};
export const getVehicleTypeLayouts = () => async (dispatch) => {
  try {
    const res = await api.get(`api/VehicleTypeLayout`);
    if (res.status === 200 && res?.data) {
      dispatch(vehicleTypesActions.getVehicleTypeLayouts(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const clearVehicleTypeById = () => async (dispatch) => {
  dispatch(vehicleTypesActions.getVehicleTypeById(''));
};
export const removeVehicleTypeAction =
  (id, setRemoveDialog) => async (dispatch) => {
    try {
      const res = await api.delete(`api/VehicleType/${id}`);
      if (res.status === 200 && res?.data) {
        dispatch(getVehicleTypesAction()).catch((error) => formErrorsHandle(error, {}));
        setRemoveDialog('');
        toast.success('Removed successfully!!!');
      }
    } catch (errors) {
      formErrorsHandle(errors.response?.data, []);
    }
  };
